import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPluscodesComponent } from './simple-icons-pluscodes.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPluscodesComponent ],
    exports:      [ SimpleIconsPluscodesComponent ],
    bootstrap:    []
})
export class SimpleIconsPluscodesModule {}
